import type { Step } from '@/components/wizard/Step';

import {
  ConnectMongoAtlasRestoreProject,
  type MongoAtlasConnectRestoreProjectState,
} from './connectMongoAtlasRestoreProject';

export const mongoAtlasConnectRestoreProjectFlow: Step<MongoAtlasConnectRestoreProjectState> =
  {
    id: 'connect_mongo_atlas_restore_project',
    Component: ConnectMongoAtlasRestoreProject,
    nonReturnable: false,
  };
